module.exports = __webpack_public_path__ + "nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf?4c01a57f19b441fe4beef02c870f4316";


//////////////////
// WEBPACK FOOTER
// ./provolution/app/views/provolution/common_assets/fonts/iconfont/nm-icons_ed0f962e28326130e817dc0e4d267a8b.ttf
// module id = 1382
// module chunks = 33